import { render, staticRenderFns } from "./PayInfo.vue?vue&type=template&id=4f60e3bd&scoped=true&"
import script from "./PayInfo.vue?vue&type=script&lang=js&"
export * from "./PayInfo.vue?vue&type=script&lang=js&"
import style0 from "./PayInfo.vue?vue&type=style&index=0&id=4f60e3bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f60e3bd",
  null
  
)

component.options.__file = "PayInfo.vue"
export default component.exports